<template>
  <div class="filter">
    <el-input
      v-model="value"
      :readonly="readonly"
      :prefix-icon="icon"
      @keyup.native="keyup"
      @clear="filter"
      clearable
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'RestListFilterInput',

  inject: ['restList'],

  props: {
    prop: {
      type: String,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: 'el-icon-search'
    },

    defaultValue: {
      required: false
    },

    filterOnEnter: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      value: null
    }
  },

  mounted() {
    if (this.defaultValue) {
      this.value = this.defaultValue
      this.filter()
    }
  },

  methods: {
    keyup: debounce(function(event) {
      if (this.filterOnEnter) {
        if (event.keyCode === 13) {
          this.filter()
        }
      } else {
        this.filter()
      }
    }, 500),

    filter() {
      this.restList.filterField(this.prop, this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterInput.vue